__turbopack_context__.v({
  "answer": "ask-motion-module-scss-module__GdbF4W__answer",
  "answerSizer": "ask-motion-module-scss-module__GdbF4W__answerSizer",
  "answerStream": "ask-motion-module-scss-module__GdbF4W__answerStream",
  "chat": "ask-motion-module-scss-module__GdbF4W__chat",
  "coach": "ask-motion-module-scss-module__GdbF4W__coach",
  "earlier": "ask-motion-module-scss-module__GdbF4W__earlier",
  "options": "ask-motion-module-scss-module__GdbF4W__options",
  "prompt": "ask-motion-module-scss-module__GdbF4W__prompt",
  "thread": "ask-motion-module-scss-module__GdbF4W__thread",
  "you": "ask-motion-module-scss-module__GdbF4W__you",
});
